export const INTERESTED_POPUP_STRINGS = {
  interested: 'Interested In This Home',
};
